import React, { useState, useRef, useContext } from 'react';
import { ApiDialogsAndModalsContext } from './apiState/apiDialogsAndModalsContext';

export const FloatingVariableWindowContext = React.createContext({
  focusedInput: null,
  focusedInpuSetterFn: null,
  focusedInputPosition: {},
  setFocusedInputPosition: () => {},
  editorRef: null,
  isEditorFocused: false,
  setIsEditorFocused: () => {},
  variableFloatingWindowRef: null,
  cursorPosition: {},
  setCursorPosition: () => {}
});

export const FloatingVariableComponentProvider = ({ children }) => {
  const { requestVariablesSuggestionList } = useContext(ApiDialogsAndModalsContext);
  const focusedInput = useRef(null);
  const editorRef = useRef(null);
  const focusedInpuSetterFn = useRef(null);
  const [focusedInputPosition, setFocusedInputPosition] = useState({ top: 200, left: 1000 });
  const [cursorPosition, setCursorPosition] = useState({ top: 200, left: 1000 });
  const [editorCursorPosition, setEditorCursorPosition] = useState({ top: 200, left: 1000 });

  const [isEditorFocused, setIsEditorFocused] = useState(false);
  const variableFloatingWindowRef = useRef(requestVariablesSuggestionList);
  const [jsonResponseFields, setJSONResponseFields] = useState({
    keys: [],
    fields: []
  });
  const [variablesFilter, setVariablesFilter] = useState('');
  const [saveHighLightedTextState, setSaveHighLightedTextState] = useState({
    highLightedValue: '',
    showModal: false,
    useCase: 'text',
    fieldEntry: {
      name: '',
      path: ''
    }
  });

  return (
    <FloatingVariableWindowContext.Provider
      value={{
        focusedInput,
        focusedInpuSetterFn,
        focusedInputPosition,
        setFocusedInputPosition,
        jsonResponseFields,
        setJSONResponseFields,
        saveHighLightedTextState,
        setSaveHighLightedTextState,
        editorCursorPosition,
        setEditorCursorPosition,
        variablesFilter,
        setVariablesFilter,
        isEditorFocused,
        setIsEditorFocused,
        editorRef,
        variableFloatingWindowRef,
        cursorPosition,
        setCursorPosition
      }}>
      {children}
    </FloatingVariableWindowContext.Provider>
  );
};
